import Splide from '@splidejs/splide'

export default function Sliders() {
	// --- Testimonials Slider ---
	const testimonials = document.querySelector('.js-testimonials')
	 
	if (testimonials) {
		const pagination = testimonials.querySelectorAll('.c-testimonials__key')

		const testimonialSlider = new Splide('.js-testimonials', {
			type: 'loop',
			arrows: false,
			pagination: false,
			keyboard: false,
			drag: false,
			rewind: true,
			autoplay: true,
			speed: 1000,
			interval: 10000,
			pauseOnHover: false,
			snap: true,
			autoHeight: true,
		})

		testimonialSlider.on('mounted', () => {
			pagination.forEach(paged => {
				if (paged.dataset.key == 1) {
					paged.classList.add('is-active')
				}
			}) 
		})

		testimonialSlider.mount()

		testimonialSlider.on('move', (newIndex) => {
			pagination.forEach(paged => {
				if (paged.dataset.key == newIndex + 1) {
					paged.classList.add('is-active')
				} else {
					paged.classList.remove('is-active')
				}
			}) 
		})
	}

	// // --- Product Feed Sliders ---
	// const productFeed = document.querySelectorAll('.js-product-slider')
	// for (let i = 0; i < productFeed.length; i++) {
	// 	new Splide(productFeed[i], {
	// 		type: 'slide',
	// 		perPage: 1,
	// 		perMove: 1,
	// 		gap: 20,
	// 		pagination: false,
	// 		arrows: true,
	// 		mediaQuery: 'min',
	// 		autoplay: false,
	// 		breakpoints: {
	// 			767: {
	// 				perPage: 2,
	// 			},
	// 			1023: {
	// 				perPage: 3,
	// 			},
	// 			1279: {
	// 				perPage: 5,
	// 			},
	// 		},
	// 		classes: {
	// 			arrows: 'splide__arrows',
	// 			arrow: 'splide__arrow',
	// 			prev: 'splide__arrow--prev',
	// 			next: 'splide__arrow--next',
	// 		},
	// 	}).mount()
	// }
}
